module.exports = __webpack_public_path__ + "media/images/default/pages/about/clinic-4-9cb122cc1da243ed91fc73ff1a1fc4f6.jpeg";